import React from 'react'

const AdminDevelopers = () => {
  return (
    <div>AdminDevelopers</div>
  )
}

export default AdminDevelopers